PJQ.views.invoicing.BillingPeriodSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-billing-period-settings'),
        minWidth: '600px',
        isEditPeriod: false
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-automated': 'toggleAutomated'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        PJQ.app.session.project.fetchBillingPeriodSettings(_.bind(function (settings) {
            this.settings = settings;
            this.isFetched = true;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            settings: this.settings
        }
    },
    afterRender: function () {
        if(!this.isFetched)
            return;

        new PJQ.Binder(this.$el, this.settings, {
            watchElements: [
                'input'
            ]
        });

        PJQ.helpers.inputHelpers.inputMaskInteger(this.$('.end-day-offset'));
        PJQ.helpers.inputHelpers.inputMaskInteger(this.$('.due-day-offset'));

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-frequency'),
            defaultValue: this.settings.get('frequency'),
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.settings.set({
                    frequency: value,
                    startDay: null,
                    endDay: null,
                    dueDay: null,
                })
                this.render();
            }, this)
        });

        this.startDayPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-start-date'),
            defaultValue: this.settings.get('startDay'),
            isMultiple: false,
            isIntChoices: true,
            choices: this.getStartEndDateChoices(),
            onChange: _.bind(function (value) {
                this.settings.set('startDay', value);
            }, this)
        });

        this.endDayPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-end-date'),
            defaultValue: this.settings.get('endDay'),
            isMultiple: false,
            isIntChoices: true,
            choices: this.getStartEndDateChoices(),
            onChange: _.bind(function (value) {
                this.settings.set('endDay', value);
            }, this)
        });

        this.dueDayPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-due-date'),
            defaultValue: this.settings.get('dueDay'),
            isMultiple: false,
            isIntChoices: true,
            choices: this.getStartEndDateChoices(true),
            onChange: _.bind(function (value) {
                this.settings.set('dueDay', value);
            }, this)
        });
    },
    // toggleAutomated: function() {
    //     this.settings.set('automated', !this.settings.get('automated'));
    //     if(!this.settings.get('automated')){
    //         this.settings.save(null, {
    //             success: _.bind(function () {
    //                 this.render();
    //             }, this)
    //         })
    //     }
    //     else {
    //         this.render();
    //     }
    // },
    save: function () {
        if(!this.validate())
            return;

        this.settings.save(null, {
            success: _.bind(function (res) {
                PJQ.notifications.notify.successNotify({
                    message: 'Billing Period Settings saved successfully'
                });

                if(typeof this.options.onSave === 'function'){
                    this.options.onSave();
                }
                this.removeModal();
            }, this)
        });
    },
    getStartEndDateChoices: function () {
        let choices = [];
        if(this.settings.get('frequency') === 0){
            // Monthly
            let date = new Date();
            let daysInMonth = 30;
            for(let i= 0; i < daysInMonth; i++){
                choices.push({
                    id: i+1,
                    name: PJQ.helpers.formatHelpers.getOrdinalSuffix(i + 1)
                });
            }

            choices.push({
                id: 31,
                name: 'Last Day'
            });
        }
        else{
            // Weekly
            for(let i= 0; i < 7; i++){
                choices.push({
                    id: i,
                    name: PJQ.helpers.dateHelpers.getDayName(i)
                });
            }
        }
        return choices;
    },
    validate: function() {
       let isValid = true;

       if(this.settings.get('startDay') == null){
           this.startDayPicker.showError('Start Day is Required');
           isValid = false;
       }

       if(this.settings.get('endDay') == null){
           this.endDayPicker.showError('End Day is Required');
           isValid = false;
       }

       if(this.settings.get('dueDay') == null){
           this.dueDayPicker.showError('Due Day is Required');
           isValid = false;
       }

       return isValid
    },
    close: function() {
        if(typeof this.options.onClose === 'function') {
            this.options.onClose();
        }
        this.removeModal();
    }
});

PJQ.views.invoicing.EditBillingPeriodModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-edit-billing-period'),
        minWidth: '600px',
        isEditPeriod: false
    },
    events: {
        'click .btn-save': 'save'
    },
    beforeModalCreated: function () {
        this.isFetched = false;
        if (this.model == null) {
            this.model = new PJQ.models.budget.BillingPeriod(null, {
                projectId: PJQ.app.session.project.id
            });
        }
        PJQ.app.session.project.fetchBillingPeriodSettings(_.bind(function (settings) {
            this.settings = settings;
            this.isFetched = true;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            model: this.model,
            settings: this.settings
        }
    },
    afterRender: function () {
        if(!this.isFetched)
            return

        new PJQ.Binder(this.$el, this.settings, {
            watchElements: [
                'input'
            ]
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.period-start'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.helpers.dateHelpers.parseDateString(this.model.get('startDate'), false)
            },
            onChange: _.bind(function (newDate) {
                this.model.set('startDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.period-end'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.helpers.dateHelpers.parseDateString(this.model.get('endDate'), false)
            },
            onChange: _.bind(function (newDate) {
                this.model.set('endDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.due-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: PJQ.helpers.dateHelpers.parseDateString(this.model.get('dueDate'), false)
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });
    },
    save: function () {
        let isNew = this.model.isNew();
        this.model.save(null, {
            success: _.bind(function () {
                this.removeModal();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(isNew ? this.model : null);
                }
                PJQ.notifications.notify.successNotify({
                    message: 'Billing Period successfully saved'
                });
            }, this)
        })
    }
});

PJQ.views.invoicing.BillingPeriodsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'billing-periods-list')
    },
    events: {
        'click .edit-period': 'editBillingPeriodClicked',
        'click .delete-period': 'deleteBillingPeriodClicked',
        'click .btn-billing-period-settings': 'billingPeriodSettings',
        'click .btn-add-billing-period': 'addBillingPeriod',
        'click .toggle-automated': 'toggleAutomated'
    },
    beforeFirstRender: function () {
        this.options.isEdit = false;
    },
    renderData: function () {
        return {
            isEdit: this.options.isEdit
        }
    },
    afterRender: function () {
        if (this.model.billingPeriods) {
            this.dataTable = new PJQ.views.dataTables.DataTable({
                el: this.$(".billing-periods-table"),
                data: this.model.billingPeriods.models,
                rowId: "cid",
                subTemplates: {
                    header: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'data-table-header-billing-periods')
                },
                headerData: {
                    settings: this.model
                },
                afterHeaderRender: _.bind(function (view, $header) {

                }, this),
                order: [1, 'desc'],
                language: {
                    zeroRecords: 'No Billing Periods currently exist'
                },
                pageLength: 25,
                onRowDoubleClick: _.bind(function (row) {
                    this.editBillingPeriod(row.data());
                }, this),
                contextMenuOptions: {
                    actions: [
                        {
                            name: 'Edit',
                            onClick: _.bind(function (row) {
                                this.editBillingPeriod(row.data());
                            }, this),
                            isShown: _.bind(function (row) {
                                return !row.data().get('automated');
                            }, this)
                        },
                        // {
                        //     name: 'Open Period',
                        //     onClick: _.bind(function (row) {
                        //         this.openBillingPeriod(row.data());
                        //     }, this),
                        //     isShown: _.bind(function (row) {
                        //         return !row.data().get('automated') && !row.data().get('isOpen');
                        //     }, this)
                        // },
                        // {
                        //     name: 'Close Period',
                        //     onClick: _.bind(function (row) {
                        //         this.closeBillingPeriod(row.data());
                        //     }, this),
                        //     isShown: _.bind(function (row) {
                        //         return !row.data().get('automated') && row.data().get('isOpen');
                        //     }, this)
                        // },
                        {
                            name: 'Delete',
                            isDanger: true,
                            onClick: _.bind(function (row) {
                                this.deleteBillingPeriod(row.data());
                            }, this)

                        }
                    ]
                },
                columns: [
                    {
                        "title": "",
                        "data": "",
                        "width": "3%",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            let icons = [];

                            if (row.get('isCurrent')) {
                                icons.push("<i class='fal fa-check text-success fs-18 mr-2' title='Active Billing Period'></i>");
                            }
                            // if(row.get('isOpen')){
                            //     icons.push("<i class='fal fa-check-circle text-success fs-18' title='Current Open Period'></i>");
                            // }

                            return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                        }, this)
                    },
                    {
                        "title": "Start Date",
                        "data": "",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('startDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    },
                    {
                        "title": 'End Date',
                        "data": "",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('endDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    },
                    {
                        "title": 'Due Date',
                        "data": "",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('dueDate')), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    },
                    {
                        "data": "",
                        "title": "",
                        "orderable": false,
                        "searchable": false,
                        "width": "160px",
                        "render": _.bind(function (data, type, row) {
                            let html = '<div class="text-align-right show-on-row-hover">'
                            if (!row.get('automated')) {
                                html += '<button type="button" class="btn btn-info edit-period ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'

                                // if(row.get('isOpen')){
                                //     html += '<button type="button" class="btn btn-danger close-period ht-30p wd-35p ml-1 fs-14" title="Close Period"><span class="fal fa-times-circle"></span></button>'
                                // }
                                // else{
                                //     html += '<button type="button" class="btn btn-success open-period ht-30p wd-35p ml-1 fs-14" title="Open Period"><span class="fal fa-check-circle"></span></button>'
                                // }
                            }
                            html += '<button type="button" class="btn btn-danger delete-period ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button>'
                            return html + '</div>'
                        }, this)
                    }
                ]
            });
        }
    },
    // openBillingPeriod: function (billingPeriod) {
    //     if(billingPeriod.get('isOpen'))
    //         return;
    //
    //     let fnCallback = () => {
    //         _.each(this.model.billingPeriods.models, (period) => {
    //             if(period.get('isOpen')){
    //                 period.set('isOpen', false);
    //             }
    //         });
    //
    //         billingPeriod.set('isOpen', true);
    //         this.dataTable.refresh();
    //     }
    //
    //
    //     new PJQ.views.modals.YesNo({
    //         header: "Send Contact Updater",
    //         body: "Opening this period will close any other open periods. Are you sure you want to open this period?",
    //         onYes: _.bind(function () {
    //             billingPeriod.openPeriod(fnCallback);
    //         }, this)
    //     });
    // },
    // closeBillingPeriod: function (billingPeriod) {
    //     if(!billingPeriod.get('isOpen'))
    //         return;
    //
    //     let fnCallback = () => {
    //         billingPeriod.set('isOpen', false);
    //         this.dataTable.refresh();
    //     }
    //
    //     new PJQ.views.modals.YesNo({
    //         header: "Send Contact Updater",
    //         body: "Closing this period will leave no open periods. Are you sure you want to close this period?",
    //         onYes: _.bind(function () {
    //             billingPeriod.closePeriod(fnCallback);
    //         }, this)
    //     });
    // },
    billingPeriodSettings: function () {
        new PJQ.views.invoicing.BillingPeriodSettingsModal({
            settings: this.model,
            onSave: _.bind(function () {
                this.render();
            }, this)
        });
    },
    addBillingPeriod: function() {
        new PJQ.views.invoicing.EditBillingPeriodModal({
            onSave: _.bind(function (billingPeriod) {
                if (billingPeriod != null) {
                    this.model.billingPeriods.add(billingPeriod);
                    this.dataTable.addRow(billingPeriod);
                }
                this.dataTable.refresh();
            }, this)
        });
    },
    editBillingPeriodClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.editBillingPeriod(row.data());
    },
    editBillingPeriod: function (period) {
        if (!period.get('automated')) {
            new PJQ.views.invoicing.EditBillingPeriodModal({
                model: period,
                onSave: _.bind(function () {
                    this.dataTable.refresh();
                }, this)
            });
        }
    },
    toggleAutomated: function() {
        if(this.model.get('automated')){
            this.model.set('automated', false);
            this.model.save(null, {
                success: _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Automated Billing Periods Disabled'
                    });
                    this.render();
                }, this)
            });
        }
        else {
            this.model.set('automated', true);
            new PJQ.views.invoicing.BillingPeriodSettingsModal({
                settings: this.model,
                onSave: (billingPeriod) => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Automated Billing Periods Enabled'
                    });

                    this.render();
                },
                onClose: () => {
                    this.model.set('automated', false);
                    this.$('.toggle-automated').prop('checked', false);
                }
            });
        }
    },
    deleteBillingPeriodClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteBillingPeriod(row.data());
    },
    deleteBillingPeriod: function (period) {
        let row = this.dataTable.getRow(period.cid);
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Billing Period",
            body: "Are you sure you want to delete this Billing Period?",
            onDelete: _.bind(function () {
                period.destroy({
                    success: _.bind(function () {
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }, this)
        });
    }
});